import { memo } from "react";

import { defaultToTrue } from "@Components/Modules/Helpers";

export default memo(
    (props: React.SVGProps<SVGSVGElement>) => (
        <svg
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            {...props}
        >
            <path d="M6 9h6M16 9h2M6 14h12" />
            <rect width="20" height="14" x="2" y="5" rx="2" />
        </svg>
    ),
    defaultToTrue,
);
